import ReadersAndIntercomIcon from "../../assets/product-list-assets/readers-and-intercom.svg";
import type { ProductListGroup } from "../../types";

export const doorAccessReadersIntercom: ProductListGroup = {
  id: "doorAccessReadersIntercom",
  title: "productListGroup.readersAndIntercom.title",
  seriesLabel: "modelCompare.seriesLabel.doorAccessReadersIntercom",
  icon: {
    src: ReadersAndIntercomIcon,
    width: 20,
    height: 20,
  },
};
